import Issues from './Issues';

export default [
  { path: '/partner/dev/issues', component: Issues, meta: { auth: true } },
]